import { Box, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import CoreJsonEditor from "../../core/inputs/CoreJsonEditor";
import { useDispatch, useSelector } from "react-redux";
import { api_request } from "../../store/actions/commonAction";
import { API_METHOD_POST } from "../../config/constants";
import {
  MASTERDATA_INSERT_JSON_ERROR,
  MASTERDATA_INSERT_JSON_SUCCESS,
} from "../../store/types/manageDataTypes";
import { setManageDataReducer } from "../../store/actions/manageDataAction";
import Swal from "sweetalert2";
import { theme } from "../../config/theme";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  maxHeight: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflowY: "auto",
};

export default function AddMasterDataJsonModal({ show, onClose }) {
  const dispatch = useDispatch();

  const masterDataInsertJsonSuccess = useSelector(
    (state) => state?.manageData?.masterDataInsertJsonSuccess
  );
  const masterDataInsertJsonError = useSelector(
    (state) => state?.manageData?.masterDataInsertJsonError
  );
  const masterDataInsertJsonMsg = useSelector(
    (state) => state?.manageData?.masterDataInsertJsonMsg
  );

  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(show);
  }, [show]);

  useEffect(() => {
    if (masterDataInsertJsonSuccess) {
      dispatch(setManageDataReducer({ masterDataInsertJsonSuccess: false }));
      Swal.fire({
        title: "Success",
        text: masterDataInsertJsonMsg,
        icon: "success",
        confirmButtonColor: theme.palette.primary.main,
      });
      setOpen(false);
    }
    if (masterDataInsertJsonError) {
      dispatch(setManageDataReducer({ masterDataInsertJsonError: false }));
      Swal.fire({
        title: "Oops!",
        text: masterDataInsertJsonMsg,
        icon: "error",
        confirmButtonColor: theme.palette.primary.main,
      });
    }
  }, [masterDataInsertJsonSuccess, masterDataInsertJsonError]);

  const onSubmit = (value) => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/MasterData/json/insert",
        { data: value },
        null,
        null,
        MASTERDATA_INSERT_JSON_SUCCESS,
        MASTERDATA_INSERT_JSON_ERROR,
        true,
        false,
        false
      )
    );
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <CoreJsonEditor
          height="350px"
          value={{}}
          onSubmit={(value) => {
            onSubmit(value);
          }}
        />
      </Box>
    </Modal>
  );
}
